import { render, staticRenderFns } from "./LogSocketList.vue?vue&type=template&id=bbddc354&scoped=true&"
import script from "./LogSocketList.vue?vue&type=script&lang=js&"
export * from "./LogSocketList.vue?vue&type=script&lang=js&"
import style0 from "./LogSocketList.vue?vue&type=style&index=0&id=bbddc354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbddc354",
  null
  
)

export default component.exports